<template>
  <ul v-if="menus.children != null">
    <template v-for="menu in menus.children">
      <li v-if="menu?.showYn === 'Y'" :key="menu.id">
        <a :href="menuHref(menu)" @click.prevent="goMenu(menu)">{{ menu.text }}</a>
        <ul>
          <template v-for="sub in menu.children">
            <li v-if="sub?.showYn === 'Y'" :key="sub.id">
              <a :href="menuHref(sub)" @click.prevent="goMenu(sub)">{{ sub.text }}</a>
            </li>
          </template>
        </ul>
      </li>
    </template>
  </ul>
  <!-- //header-area -->
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "SiteHeader",
  //props: ["menuList"],
  data: function () {
    return {
      userMap: {},
      menu: null,
      loading: false,
      menus: [],
    };
  },
  created() {},
  methods: {
    setMenuList(menuList) {
      this.loading = false;
      if (menuList == null || menuList.children == null) return;

      this.menus = menuList;
      this.getMenuScript();
    },
    menuHref(item) {
      const url = item.url?.replace(/^\/usr/, "") || item.url;
      return url ? this.$router.resolve(url).href : undefined;
    },
    goMenu(item) {
      localStorage.setItem("MENU", item.id);

      const url = item.url?.replace(/^\/usr/, "") || item.url;
      this.$router.push(url).catch(() => {});
    },
    getMenuScript() {
      this.$nextTick(() => {
        try {
          const $ = window.$ || window.jQuery;
          if (!$) return;
          const $header = $(".site-header");
          if (typeof $header.headerFunc === "function") $header.headerFunc();
          const $gnb = $(".site-gnb");
          if (typeof $gnb.gnbFunc === "function") $gnb.gnbFunc();
          const $nav = $(".site-nav-area");
          if (typeof $nav.navFunc === "function") $nav.navFunc();
          const $mn = $(".mn-top");
          if (typeof $mn.mnTopFunc === "function") $mn.mnTopFunc();
        } catch (e) {
          console.warn("[SiteHeader] getMenuScript:", e.message);
        }
      });
    },
  },
  computed: {
    ...mapGetters(["routeParams", "currentUser", "currentMenu"]),
  },
};
</script>
